import { getBackgroundColor, getColor, getOutlineColor, } from '../../colors/colors.alias';
import { getOutlineOffset, getOutlineStyle, getOutlineWidth, } from '../../borders/borders.alias';
import { getLineHeight, getFontSize, getFontFamily, } from '../../typography/typography.alias';
import { VARIANT_DEFAULT, VARIANT_ATTENTIONAL_ORDERED, VARIANT_UNORDERED, VARIANT_ATTENTIONAL_UNORDERED, ELEMENT_LIST_ITEM, ELEMENT_MARKER, ELEMENT_CIRCLE, ELEMENT_TEXT, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, } from '../../constants';
import { constants as Circle } from '../Circle';
export const constants = Object.freeze({
    NAME: 'ListItem',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_ATTENTIONAL_ORDERED,
        VARIANT_UNORDERED,
        VARIANT_ATTENTIONAL_UNORDERED,
    },
    elements: {
        ELEMENT_CIRCLE,
        ELEMENT_LIST_ITEM,
        ELEMENT_MARKER,
    },
    interactionStates: {
        INTERACTION_STATE_ACTIVE,
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getListItem(transformer, config) {
    const backgroundColor = getBackgroundColor(transformer, config);
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_MARKER]: {
                variants: {
                    [VARIANT_UNORDERED]: {
                        styles: {
                            fontSize: fontSize.body.m.value,
                            lineHeight: lineHeight.body.get(fontSize.body.m.value),
                        },
                        component: {
                            [Circle.NAME]: {
                                variant: Circle.variants.VARIANT_XS,
                            },
                        },
                    },
                    [VARIANT_ATTENTIONAL_UNORDERED]: {
                        styles: {
                            fontSize: fontSize.body.m.value,
                            lineHeight: lineHeight.body.get(fontSize.body.m.value),
                        },
                        component: {
                            [Circle.NAME]: {
                                variant: Circle.variants.VARIANT_XS_ATTENTIONAL,
                            },
                        },
                    },
                    [VARIANT_ATTENTIONAL_ORDERED]: {
                        component: {
                            [Circle.NAME]: {
                                variant: Circle.variants.VARIANT_SMALL_ATTENTIONAL,
                            },
                        },
                    },
                },
            },
            [ELEMENT_LIST_ITEM]: {
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        styles: {
                            backgroundColor: backgroundColor.listItem.interactionStates[INTERACTION_STATE_ACTIVE].value,
                        },
                    },
                    [INTERACTION_STATE_HOVER]: {
                        styles: {
                            backgroundColor: backgroundColor.listItem.interactionStates[INTERACTION_STATE_HOVER].value,
                        },
                    },
                    [INTERACTION_STATE_FOCUS_VISIBLE]: {
                        styles: {
                            outlineOffset: outlineOffset.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineWidth: outlineWidth.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
            },
            [ELEMENT_TEXT]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.body.m.value,
                    lineHeight: lineHeight.body.get(fontSize.body.m.value),
                    color: color.text.default.value,
                },
            },
        },
    });
}
